// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Payload = /** @class */ (function () {
    function Payload() {
    }
    return Payload;
}());
exports.Payload = Payload;
//# sourceMappingURL=Payload.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/payload/Payload.js
// module id = 486
// module chunks = 0